import React from 'react';
import PropTypes from 'prop-types';
import Button from '@mui/material/Button';
import {Icon} from '@/components/atoms';

const DateRangeCustomInput = React.forwardRef(
  (
    {
      value = '',
      onClick,
      column,
      sx,
      dateRanges,
      setOpenDatePicker,
      className = ''
    },
    ref
  ) => {
    if (!column?.name_of_db_column) return null;

    const dateRange = dateRanges[column.name_of_db_column] || {};
    const {startDate, endDate} = dateRange;
    const showCross = startDate && endDate;
    const showCalendar = !showCross;

    let buttonText;
    if (startDate && endDate) {
      buttonText = `${startDate.toLocaleDateString()} - ${endDate.toLocaleDateString()}`;
    } else if (startDate) {
      buttonText = `${startDate.toLocaleDateString()} - End Date`;
    } else {
      buttonText = value || column.label_of_column;
    }

    return (
      <Button
        ref={ref}
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          setOpenDatePicker(column.name_of_db_column);
          onClick?.(e);
        }}
        variant='outlined'
        size='small'
        fullWidth
        className={`${className} date-button-input ${showCalendar ? 'is-placeholder' : ''}`}
        sx={{...sx, textTransform: 'none'}}>
        <div
          className='date-button-content'
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            width: '100%'
          }}>
          <div className='date-button-text' style={{fontSize: '12px'}}>
            {buttonText}
          </div>
          {showCalendar ? <Icon icon='calendar_today' size='small' /> : null}
        </div>
      </Button>
    );
  }
);

DateRangeCustomInput.propTypes = {
  value: PropTypes.string,
  onClick: PropTypes.func,
  column: PropTypes.shape({
    name_of_db_column: PropTypes.string.isRequired,
    label_of_column: PropTypes.string
  }).isRequired,
  sx: PropTypes.object,
  dateRanges: PropTypes.object.isRequired,
  setOpenDatePicker: PropTypes.func.isRequired,
  className: PropTypes.string
};

export default DateRangeCustomInput;
